import { RenderContext } from "vue/types/options";

export default ({ props, slots }: RenderContext) => (
    <li class={["nav-item", props.outerClass]}>
        <router-link class={["nav-link", props.innerClass]} to={props.route.path}>
            {slots().default}
        </router-link>
    </li>
);
